import type { Language } from "@helpers/I18nHelper";
import FaqSupport from "@modules/faq-support/pages/FaqSupport";
import HowToBuyChampions from "@modules/help-center/pages/HowToBuyChampions";
import HowToChangeEmailAndPassword from "@modules/help-center/pages/HowToChangeEmailAndPassword";
import HowToChangeRiotIdAndUsername from "@modules/help-center/pages/HowToChangeRiotIdAndUsername";
import HowToHandleBannedAccount from "@modules/help-center/pages/HowToHandleBannedAccounts";
import HowToSaveSettings from "@modules/help-center/pages/HowToSaveSettings";
import HowToUnlockSkinsWithShards from "@modules/help-center/pages/HowToUnlockSkinsWIthShards";
import i18next from "i18next";
import type { RouteObject } from "react-router";

const getFAQRoutes = (lang: Language): RouteObject[] => {
  const t = (key: string) => i18next.t(`routes.public.${key}`, { lng: lang });

  return [
    {
      element: <FaqSupport />,
      path: t("faq"),
      handle: { routeId: "faq" },
    },
    {
      element: <HowToChangeEmailAndPassword />,
      path: t("faq_change_email"),
      handle: { routeId: "faq_change_email" },
    },
    {
      element: <HowToChangeRiotIdAndUsername />,
      path: t("faq_change_riot_id"),
      handle: { routeId: "faq_change_riot_id" },
    },
    {
      element: <HowToUnlockSkinsWithShards />,
      path: t("faq_get_skins"),
      handle: { routeId: "faq_get_skins" },
    },
    {
      element: <HowToBuyChampions />,
      path: t("faq_cannot_buy_champions"),
      handle: { routeId: "faq_cannot_buy_champions" },
    },
    {
      element: <HowToSaveSettings />,
      path: t("faq_save_settings"),
      handle: { routeId: "faq_save_settings" },
    },
    {
      element: <HowToHandleBannedAccount />,
      path: t("faq_account_banned"),
      handle: { routeId: "faq_account_banned" },
    },
  ];
};

export default getFAQRoutes;
